import React from 'react'
import ReactDOMServer from 'react-dom/server'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'

const TotalBoxContainer = styled.div`
  height: ${props => (props.small ? '43px' : '66px')};
  width: ${props => (props.small ? '43px' : '66px')};
  border-radius: 5px;
  background: ${props => props.background};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const StyledTooltip = styled(ReactTooltip)`
  width: 244px;
`
class TotalBox extends React.Component {
  render() {
    return (
      <TotalBoxContainer
        background={this.props.background}
        small={this.props.small}
        style={this.props.style}
        data-for={this.props.tooltipId}
        data-tip={ReactDOMServer.renderToStaticMarkup(this.props.tooltipText)}
        data-html={true}
      >
        <StyledTooltip id={this.props.tooltipId} effect="solid" />
        {this.props.children}
      </TotalBoxContainer>
    )
  }
}

TotalBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  background: PropTypes.string.isRequired,
  small: PropTypes.bool,
  tooltipId: PropTypes.string,
  tooltipText: PropTypes.string,
  style: PropTypes.symbol
}

export default TotalBox



// WEBPACK FOOTER //
// ./src/components/productionstatus/TotalBox.js